import React, { useState, useEffect, useRef } from 'react';
import FullPageLoader from '../../components/full-page-loader/full-page-loader';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { beforeCategory, getCategories } from '../categories/categories.action';
import Collections from './collections';
import { ENV } from '../../config/config';
import ReactTooltip from 'react-tooltip';
import { Tabs, Tab, Row, Col } from "react-bootstrap"

const initData = {
    pre_heading: "Collections",
    heading: "My Collections",
    content: "Create and manage collections of unique NFTs to share and sell.",
    btnText: "Create New"
}

const MyCollections = (props) => {
    const [categories, setCategories] = useState(null)
    const [categoriesLoader, setCatLoader] = useState(true) // categories loader
    const [collectionsLoader, setColLoader] = useState(true) // collections loader
    const collectionsRef = useRef(null)
    const navigate = useNavigate();
    const { _id } = ENV.getUserKeys('_id');

    useEffect(() => {
        if (_id) {
            window.scroll(0, 0)
            props.getCategories()
        }
        else {
            navigate('/login')
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // when categories data is received
    useEffect(() => {
        if (props.category.getAuth) {
            const { categories } = props.category
            const allCat = { active: true, name: 'all' }
            setCategories([allCat, ...categories])
            props.beforeCategory()
            setCatLoader(false)
        }
    }, [props.category.getAuth]) // eslint-disable-line react-hooks/exhaustive-deps

    const getColLoader = (loader) => {
        setColLoader(loader)
    }

    const getCatCollections = (catId) => {
        collectionsRef.current?.getCatCollections(catId)
    }

    return (
        <>
            {(categoriesLoader || collectionsLoader) && <FullPageLoader/>}
            <section className="explore-area collection-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="intro d-flex justify-content-between align-items-center m-0">
                                <div className="my-collection">
                                    <h3>{initData.heading}</h3>
                                </div>
                                <div className="intro-btn">
                                    <Link className="btn content-btn text-left" to="/collection/create">{initData.btnText}</Link>
                                </div>
                            </div>
                            <div className="intro my-3">
                                <p>{initData.content} <i className="fas fa-exclamation-circle cursor-pointer ml-2" data-effect="float" data-tip={`Collections can be created either directly on ${ENV.appName} or importing from an exitsing smart contract.`} />
                                </p>
                                <ReactTooltip />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center text-center">
                        <div className="col-12">
                            <div className="explore-menu btn-group-toggle d-flex justify-content-start flex-wrap" data-toggle="buttons">
                                {
                                    categories && categories.length > 0 &&
                                    categories.map((item, index) => {
                                        return (
                                            <label onClick={() => getCatCollections(item._id)} key={`cat_${index}`} className={`btn ${item.active ? 'active' : ''} text-uppercase p-2 d-flex align-items-center`}>
                                                <input type="radio" defaultValue={item.name} defaultChecked className="explore-btn" />
                                                <span>{item.name}</span>
                                            </label>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} noDefault={true}/>
                {/* <Tabs defaultActiveKey="trending" id="uncontrolled-tab-example" className="mb-3">
                    <Tab eventKey="trending" title="Trending">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="pfp" title="PFP">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="top" title="Top">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="art" title="Art">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="collectibles" title="Collectibles">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="domain" title="Domain Names">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="sports" title="Sports">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="music" title="Music Utility">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="metaverse" title="Metaverse">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="cards" title="Trending Cards">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                    <Tab eventKey="photography" title="Photography">
                        <Collections userId={_id} setLoader={getColLoader} ref={collectionsRef} />
                    </Tab>
                </Tabs> */}
                
            </section>
        </>
    );
}

const mapStateToProps = state => ({
    error: state.error,
    category: state.category
});

export default connect(mapStateToProps, { beforeCategory, getCategories })(MyCollections);
